export const text = {
  CONFIRM_CANCELLATION: 'Confirm cancellation',
  CANCELLATION_MESSAGE:
    'This will not cancel the order with the pharmacy. You must confirm the order has been canceled with the pharmacy before confirming cancellation.',
  CANCELLATION_QUESTION: 'Are you sure you wish to confirm cancellation?',
  ADDITIONAL_INFORMATION: 'How did you verify the cancellation? (Example: Called pharmacy, spoke to John)*',
}
